import { useEffect, useState } from "react";
import { scrollWindowTo } from "../../js/utils/scrollToFooter";

export default function FooterReturnTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 160);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="footer-return-top"
      data-tour="footer-top"
      onClick={() => scrollWindowTo(0)}
      aria-label="Return to top of page"
    >
      Top
    </button>
  );
}
